export enum BalanceGroup {
    Hour = 0,
    Day = 1,
    Month = 2,
    Year = 3,
}

export interface BalanceHistoryRequest {
    fromUtc: string;
    toUtc: string;
    group: BalanceGroup;
}

export interface BalanceHistoryItemDto {
    siteBalance: number;
    tomeBalance: number;
    gameMoneyBalance: number;
    date: string;
}


